import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <Helmet>
        <title>FitCalendar Privacy Policy</title>
        <link rel="canonical" href="https://fitcalendar.praxipro.io/privacy/" />
        <meta name="title" content="FitCalendar Privacy Policy" />
        <meta name="description" content="Learn how FitCalendar protects your personal data and respects your privacy. Read our comprehensive privacy policy for our yoga, Pilates, and fitness studio booking software." />
        <meta name="author" content="PraxiPro" />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fitcalendar.praxipro.io/privacy/" />
        <meta property="og:title" content="FitCalendar Privacy Policy - Your Data Protection & Privacy" />
        <meta property="og:description" content="FitCalendar is committed to protecting your personal information. Read our privacy policy for details on data collection, usage, and security." />
        <meta property="og:image" content="/og-image.png" />
        <meta property="og:site_name" content="FitCalendar" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://fitcalendar.praxipro.io/privacy/" />
        <meta name="twitter:title" content="FitCalendar Privacy Policy - Your Data Protection & Privacy" />
        <meta name="twitter:description" content="Your privacy matters to FitCalendar. Review our privacy policy to understand how we collect, use, and safeguard your data." />
        <meta name="twitter:image" content="/og-image.png" />
        <meta name="twitter:creator" content="@PraxiPro" />

        <meta itemProp="name" content="FitCalendar Privacy Policy - Your Data Protection & Privacy" />
        <meta itemProp="description" content="FitCalendar’s privacy policy explains how we handle your personal information responsibly for yoga, Pilates, and fitness studio software users." />
        <meta itemProp="image" content="/og-image.png" />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <h1 className="text-3xl font-bold mb-8">{t('privacy.title')}</h1>
      <div className="termsContainer">
        <div className="termsContainer">
          <h2>{t('privacy.introduction.title')}</h2>
          <p>{t('privacy.introduction.description')}</p>

          <h2>{t('privacy.dataController.title')}</h2>
          <p>{t('privacy.dataController.description')}</p>

          <h2>{t('privacy.dataCollected.title')}</h2>
          <p>{t('privacy.dataCollected.description')}</p>
          <ul>
            <li>{t('privacy.dataCollected.points.account')}</li>
            <li>{t('privacy.dataCollected.points.booking')}</li>
          </ul>

          <h2>{t('privacy.purpose.title')}</h2>
          <p>{t('privacy.purpose.description')}</p>
          <ul>
            <li>{t('privacy.purpose.points.account')}</li>
            <li>{t('privacy.purpose.points.booking')}</li>
            <li>{t('privacy.purpose.points.compliance')}</li>
          </ul>

          <h2>{t('privacy.dataSharing.title')}</h2>
          <ul>
            <li>{t('privacy.dataSharing.points.fitnessStudios')}</li>
          </ul>

          <h2>{t('privacy.dataSecurity.title')}</h2>
          <p>{t('privacy.dataSecurity.description')}</p>

          <h2>{t('privacy.dataRetention.title')}</h2>
          <ul>
            <li>{t('privacy.dataRetention.points.retention')}</li>
            <li>{t('privacy.dataRetention.points.deletion')}</li>
          </ul>

          <h2>{t('privacy.userRights.title')}</h2>
          <p>{t('privacy.userRights.description')}</p>
          <ul>
            <li>{t('privacy.userRights.points.access')}</li>
            <li>{t('privacy.userRights.points.object')}</li>
            <li>{t('privacy.userRights.points.portability')}</li>
          </ul>

          <h2>{t('privacy.contact.title')}</h2>
          <p>{t('privacy.contact.description')}</p>

          <h2>{t('privacy.changes.title')}</h2>
          <p>{t('privacy.changes.description')}</p>
          <br />
          <p>{t('privacy.consent.description')}</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;